import { useEffect } from "react";
import { useLocalStorage } from "@shared/hooks";
import { useDispatch, useSelector } from "react-redux";
import { actions as sharedActions } from "@shared/store";
import { INTEGRATIONS_REISIFT_MODAL, MODAL_TYPES } from "@shared/constants";
import { ModalSize } from "@shared/interfaces";
import { checkIfAdmin } from "@shared/utils/ACL";
import { isPrimaryUser } from "@shared/utils/functions";
import { getUserDetails } from "@shared/store/selectors";
import { useFeatureEnabledCheck } from "@shared/hooks/FeatureHook";
import { Feature } from "@shared/models";
import { impersonated } from "@containers/Auth/store/selectors";
import { useSearchParams } from "react-router-dom";

import { useFetchReiSiftIntegrationSummary } from "./useFetchReiSiftIntegrationSummary";

export const Integrations = () => {
  const dispatch = useDispatch();
  const isAdmin = checkIfAdmin();
  const user = useSelector(getUserDetails());
  const isPrimaryUserAccount = isPrimaryUser(user);
  const isIntegrationEnabled = useFeatureEnabledCheck(Feature.ReiSift);
  const isImpersonated = useSelector(impersonated());

  const [showReisiftModal, setShowReisiftModal] = useLocalStorage(INTEGRATIONS_REISIFT_MODAL, true, {
    initializeWithValue: false,
  });

  const [searchParams] = useSearchParams();

  const accessToken = searchParams.get("access_token");

  const { data } = useFetchReiSiftIntegrationSummary();

  useEffect(() => {
    if (accessToken) return;
    if (!isAdmin && !isImpersonated && isPrimaryUserAccount && isIntegrationEnabled && data?.status === false) {
      setTimeout(() => {
        if (showReisiftModal === true) {
          dispatch(
            sharedActions.showModal({
              type: MODAL_TYPES.REISIFT_INTEGRATION,
              size: ModalSize.RESIZABLE,
              props: {},
            }),
          );
        }
      }, 500);
    }
  }, [
    dispatch,
    setShowReisiftModal,
    isAdmin,
    isImpersonated,
    isPrimaryUserAccount,
    isIntegrationEnabled,
    showReisiftModal,
    data?.status,
    accessToken,
  ]);

  return null;
};
